module.exports = __webpack_public_path__ + "b111e77dd8dbe862e505ee4697e442fa.pdf";